import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { useRef } from 'react';
import Errors from './Errors';
import Input from './Input';

const FlexRow = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  > div {
    flex-basis: 31%;
  }
`;

const formatDate = ({ day, month, year }) => `${day}-${month}-${year}`;

const SplitDate = ({ value: valueArg = '--', ...props }) => {
  // matches date format 'd-m-Y' (inc '' and '--')
  let match = valueArg?.match(/^(\d{0,2})?(?:-(\d{0,2}))?(?:-(\d{0,4}))?$/);
  if (valueArg === null || match === null) {
    console.error(`Invalid value format in SplitDate component:
      received ${valueArg}
      expected format string 'd-m-Y'`);
    match = [];
  }
  const [, day = '', month = '', year = ''] = match;

  const dayInput = useRef(null);
  const monthInput = useRef(null);
  const yearInput = useRef(null);

  const onChangeHandler = (name, value) => props.onChange(formatDate({ day, month, year, [name]: value }));

  const onKeyDownHandler = e => {
    const { key, target } = e;
    const specialKeys = ['Meta', 'Ctrl', 'Alt', 'Tab', 'ArrowRight', 'ArrowLeft', 'Delete', 'Enter'];
    const whitelistedKeys = [...'0123456789', 'Backspace'];
    if (specialKeys.some(k => k === key)) return;
    if (!whitelistedKeys.includes(key)) e.preventDefault();
    if (String(window.getSelection())) target.value = '';
    const { value, name, maxLength } = target;

    if (value.length === maxLength && whitelistedKeys.includes(key) && key !== 'Backspace') {
      if (name === 'day') {
        onChangeHandler('month', '');
        monthInput.current.focus();
      }
      if (name === 'month') {
        onChangeHandler('year', '');
        yearInput.current.focus();
      }
    } else if (!value.length && key === 'Backspace') {
      if (name === 'year') monthInput.current.focus();
      if (name === 'month') dayInput.current.focus();
    }
  };

  return (
    <div>
      <FlexRow>
        <Input
          {...props}
          value={day}
          placeholder="Dag"
          type="text"
          inputMode="numeric"
          name="day"
          autoFocus={props.autoFocusDay}
          onChange={({ target: { name, value } }) => onChangeHandler(name, value)}
          inputRef={dayInput}
          onKeyDown={onKeyDownHandler}
          showTextErrors={false}
          maxLength={2}
        />
        <Input
          {...props}
          name="month"
          placeholder="Maand"
          type="text"
          inputMode="numeric"
          value={month}
          autoFocus={props.autoFocusMonth}
          onChange={({ target: { name, value } }) => onChangeHandler(name, value)}
          inputRef={monthInput}
          onKeyDown={onKeyDownHandler}
          showTextErrors={false}
          maxLength={2}
        />
        <Input
          {...props}
          placeholder="Jaar"
          type="text"
          inputMode="numeric"
          name="year"
          value={year}
          autoFocus={props.autoFocusYear}
          onChange={({ target: { name, value } }) => onChangeHandler(name, value)}
          inputRef={yearInput}
          onKeyDown={onKeyDownHandler}
          showTextErrors={false}
          maxLength={4}
        />
      </FlexRow>
      <Errors errors={props.errors} />
    </div>
  );
};

SplitDate.propTypes = {
  autoFocusDay: PropTypes.bool,
  autoFocusMonth: PropTypes.bool,
  autoFocusYear: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  errors: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
};

SplitDate.defaultProps = {
  autoFocusDay: false,
  autoFocusMonth: false,
  autoFocusYear: false,
  onChange: () => {},
  errors: null,
};

export default SplitDate;
